import React from "react";
import { Link } from "react-router-dom";

export const TeamAreaOneItem = ({ member }) => {
  return (
    <div className="team-item">
      <div className="team-thumb">
        <img src={member.src} alt="" />
      </div>

      <div className="team-content">
        <h2 className="title">
          <Link to={member.href}>{member.title} </Link>
        </h2>

        <span>{member.designation} </span>
      </div>
    </div>
  );
};

